<div
  [dfs]="[data.type === 'success' && 'c:3 bg:32', data.type === 'error' && 'c:2 bg:22', data.type === 'warning' && 'c:9 bg:92', 'br:2px p-h:14px p-v:16px']">
  <div [dfs]="'d:flex'">
    <p [dfs]="'t:s1 flex-grow:1'">{{ data.title }}</p>
    <icms-icon [dfs]="'flex-shrink:0 p-a:8px m-v:-12px cursor:pointer'"
      [icon]="'close'"
    (click)="close($event)"></icms-icon>
  </div>
  @if (data.copy) {
    <div [dfs]="'c:14 m-t:6px t:p2 o-y:auto max-height:400px'"
    [innerHTML]="data.copy"></div>
  }
</div>